import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { PRACTICE, IMAGES } from "@/data/practice";

const values = [
  "Infirmiers diplômés d'État",
  "Écoute, discrétion et bienveillance",
  "Continuité des soins 7j/7",
  "Coordination avec votre médecin traitant",
];

export const About = () => {
  return (
    <section
      id="equipe"
      data-testid="about-section"
      className="py-20 sm:py-28 bg-[#FAF9F6]"
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="relative order-2 lg:order-1"
        >
          <div className="rounded-[2rem] overflow-hidden shadow-[0_20px_60px_rgb(0,0,0,0.12)] aspect-[5/4]">
            <img
              src={IMAGES.team}
              alt="Infirmier prenant soin d'une dame âgée à domicile à Bordeaux"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="absolute -bottom-5 right-4 bg-[#3F9E8E] text-white rounded-2xl px-6 py-4 shadow-lg">
            <p className="font-display font-bold text-2xl leading-none">5,0 ★</p>
            <p className="text-xs mt-1 text-white/90">Note Google · {PRACTICE.reviewCount} avis</p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="order-1 lg:order-2"
        >
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#3F9E8E] mb-4">
            Votre équipe soignante
          </p>
          <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#2C362B] leading-tight">
            Clément Bousquet & Nicolas Pascault
          </h2>
          <p className="mt-5 text-base sm:text-lg text-[#4A554A] leading-relaxed">
            Infirmiers libéraux diplômés d'État, nous vous accompagnons avec
            professionnalisme et proximité. Notre priorité : des soins de qualité,
            dans le respect de votre confort et de votre intimité.
          </p>

          <ul className="mt-8 grid sm:grid-cols-2 gap-3">
            {values.map((v) => (
              <li key={v} className="flex items-start gap-3">
                <span className="flex-shrink-0 grid place-items-center w-6 h-6 rounded-full bg-[#E3E7E0] text-[#6B7A66] mt-0.5">
                  <Check className="w-3.5 h-3.5" strokeWidth={2.5} />
                </span>
                <span className="text-sm text-[#2C362B]">{v}</span>
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </section>
  );
};
